
import React,{useState,useRef,memo,useCallback,useEffect} from 'react'
import {getContentPath} from  'system/AssetManager'
import {animateParallax,getAnimationModel,animateIntersect,setInitialAnimIntersectState,setFinalAnimIntersectState} from './CanvasAnimator'
import Globals from 'system/Globals'
import Poster from 'assets/img/poster.jpg'
import {ReactComponent as PlayBtn} from 'assets/icons/deck-play-btn.svg'
import classNames from 'classnames'

function VideoComponent(props){
    
    
    const [inline,setInline] = useState({})
    const [vidSrc,setVidSrc] = useState(null)
    const [canPlay, setCanPlay] = useState(false);
    
    let bLoaded=false
    const refEle = useRef()
    const refVid = useRef()
    const reloadCount = useRef();
    const refFormat = useRef()
    const refOrigOffset = useRef(0)
    const refAnimationModel = useRef({})
    // eslint-disable-next-line no-unused-vars
    const [isAutoplay, setIsAutoplay] = useState(true);
    const [isPlaying, setIsPlaying] = useState(false);
    const [vidStyle,setVidStyle] = useState({width:"100%",height:"100%",objectFit:props.fit?props.fit:'cover'})
    const refLastLoadComplete = useRef(0);
    const refLastAnimComplete = useRef(0);


    useEffect(()=>{ 
        refOrigOffset.current=refEle.current.offsetLeft
        if(refFormat.current && refFormat.current.animation){
            refAnimationModel.current = getAnimationModel(refEle.current,refFormat.current.animation) 
            if(props.renderOnly===true){
                setFinalAnimIntersectState(refEle.current,refFormat.current.animation)
            }
            // console.log('refFormat.current', refFormat.current)
            if (refFormat.current.loop) {
                refVid.current.loop = true
            } 
    
        }
        
    },[inline]) // eslint-disable-line react-hooks/exhaustive-deps
    
    const onScroll = useCallback((scrollLeft,scale,pageWidth)=>{
        // console.log(refAnimationModel.current)
        animateParallax(refEle.current,refAnimationModel.current,scrollLeft,pageWidth)
    },[props.model.animation,refEle])// eslint-disable-line react-hooks/exhaustive-deps

    const onIntersect = useCallback((evt,threshold)=>{
        // console.log('VID onIntersect', refFormat.current, threshold)
        if (refFormat.current.loop) {
            refVid.current.loop = true
        } 

        // console.log('onINTERSECT video', evt.detail.isIntersecting, refFormat.current)

        if(evt.detail.isIntersecting )
        {
            if(evt.detail.intersectionRatio >=threshold)
                animateIntersect(refEle.current,refAnimationModel.current)  
            if(evt.detail.intersectionRatio >=0.5)
                if (refFormat.current.autoplay) {
                    // refVid.current.play()
                    console.log('play')
                }
              
            
        }
        else if(evt.detail.intersectionRatio <=0.001) {
            setInitialAnimIntersectState(refEle.current,refAnimationModel.current)
            if (refVid.current.currentTime > 0) {
                refVid.current.pause()
                refVid.current.currentTime = 0;
            }
            
            }
        else if(evt.detail.intersectionRatio <=0)
            if (refVid.current.currentTime > 0) {
                refVid.current.pause()
                refVid.current.currentTime = 0;
            }
            console.log('pause')
    


    },[refEle, refVid])


    const onAnim = useCallback((evt,threshold)=>{
            const currentTime = Date.now();
            const timeSinceLastCall = currentTime - refLastAnimComplete.current;
            
            // Prevent execution if called within 1 second (1000ms)
            if (timeSinceLastCall < 1000) {
                console.log('onAnim VIDEO throttled - called too soon', {
                    index: props.index,
                    videoId: refVid.current?.id,
                    timeSinceLastCall,
                    remaining: 1000 - timeSinceLastCall
                });
                return;
            }
            
            // Update the last execution time
            refLastAnimComplete.current = currentTime;
            
            console.log('VID onAnim', evt, threshold, refFormat.current)
            

            if (refFormat.current.loop && refVid.current) {
                refVid.current.loop = true
            }            
            if(evt)
            {
                animateIntersect(refEle.current,refAnimationModel.current)  
              
                if (refFormat.current.autoplay && refVid.current) {
            
                    try {
                        if (refVid.current.paused) {
                            refVid.current.currentTime = 0;
                            refVid.current.play();
                            console.log('vid play', refVid.current.id)
                        }
                        
                    } catch (error) {
                        console.error('vid play error', error)
                    }
                   
                }
            }
            else {
                setInitialAnimIntersectState(refEle.current,refAnimationModel.current)
                refVid.current.pause()
                refVid.current.currentTime = 0;
                console.log('vid paused', refVid.current.id)
            }
                
        },[refEle, refVid])

    useEffect(()=>{
        // console.log(props.model,props.format)
        refFormat.current = Globals.instance().getCanvasFormat(props.model.formats,props.format)
        
        let style ={position:'absolute',transform: 'translateZ(0), perspective: 1000px',willChange:'transform'}

        if (refFormat.current && refVid) {
            if(refFormat.current.style){ style = Object.assign(style,refFormat.current.style) }
        
            let f = refFormat.current.file?refFormat.current.file:refFormat.current.image
            setVidSrc(getContentPath(f))
            // console.log("seting ",getContentPath(f))

            console.log('refFormat', refFormat.current, props.model.formats)

            // console.log("FORMAT", refFormat.current, props.model.formats, props.format, f)

            //set up animation Type
            if(refFormat.current.animation ){
                console.log('VIDEO animation config:', refFormat.current.animation, 'index:', props.index)
                if(refFormat.current.animation.typeName==='parallax'){
                    props.setScrollCallback(onScroll,props.index)
                    style.willChange='transform'
                } 
                else if(refFormat.current.animation.typeName==='page'){
                    console.log('Registering onAnim for VIDEO index:', props.index)
                    props.onIntersect(onIntersect,props.index)
                    props.onAnim(onAnim, props.index)
                    style.willChange='transform, scale, opacity'
                }
            } else {
                console.log('VIDEO has NO animation config, index:', props.index)
            }

            
            
            

            
        }
        // console.log('style', props.model.formats, Globals.instance().getCanvasFormat(props.model.formats,props.format))
        setInline(style)

        return ()=>{
            //cleanup
        
        }
        
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])




    useEffect(() => {
        if (vidSrc) {
            if (refVid.current) {
                refVid.current.load();
                // refVid.current.currentTime = 0;
              }
        }
    }, [vidSrc])

    useEffect(() => {
        if (canPlay){
            if (refFormat.current.autoplay) {
                try {
                    if (refVid.current.paused) {
                        refVid.current.play();
                    }
                    
                } catch (error) {
                    console.error('vid play error', error)
                }
                
            
            }
        }
    }, [canPlay])


    function onError(evt){
        console.error("video load error"+bLoaded, evt.target.src)
        // onErrorLoad(evt)
        console.log("src "+evt.target.src)
        if(!bLoaded && vidSrc!==""){
            Globals.instance().trackError('Video '+vidSrc+' ',false)
            onLoad() //dont hold up the page 
        }
    }
    
    function onLoad(){
      
        const currentTime = Date.now();
        const timeSinceLastCall = currentTime - refLastLoadComplete.current;
        
        // Prevent execution if called within 1 second (1000ms)
        if (timeSinceLastCall < 1000) {
            console.log('onLoad VIDEO throttled - called too soon', {
                index: props.index,
                videoId: refEle.current?.id,
                timeSinceLastCall,
                remaining: 1000 - timeSinceLastCall
            });
            return;
        }
        
        // Update the last execution time
        refLastLoadComplete.current = currentTime;

        console.log('onLoad VIDEO', props.index, refEle.current.id)

        // Ensure video starts at beginning
        if (refVid.current) {
            refVid.current.currentTime = 0;
        }
        
        //down res the image
        if(!bLoaded){
            setCanPlay(true);
            props.onLoad(props.index,refEle.current,props.model)
            
            bLoaded=true

            if(props.renderOnly===true){
                refAnimationModel.current = getAnimationModel(refEle.current,refFormat.current.animation) 
                setFinalAnimIntersectState(refEle.current,refAnimationModel.current)
            }

         

        }
        
    }    


    function onClickVideo(e) {
        props.onClickElem('video', e.target, null)
        if (refVid.current) {
            if (refVid.current.paused) {
        
                setIsPlaying(false);
            } else {
          
                setIsPlaying(true);
            }
        }
        
    }
    
    const handleRetry = (e) => {

        if (refVid.current) {
          // Reload the video
          if (reloadCount.current <2) {
            refVid.current.load();
            reloadCount.current+=1
            onLoad()
            if (refFormat.current.autoplay) {
            
                try {
                    if (refVid.current.paused) {
                        // refVid.current.play();
                    }
                    
                } catch (error) {
                    console.error('vid play error', error)
                }
            
            }
            console.log('reloading video')
          } else {
            console.error('video loading error', e)
          }
       
        }
      };
    
    return ( 
        <div style={inline} ref={refEle} id={refFormat.current && "component_dim_file_" + refFormat.current.component} data-opacity={inline.opacity} data-fileformat={refFormat.current && refFormat.current.file}>

        <span className={classNames("play-btn", !isPlaying && "paused")}>
            <PlayBtn  />
        </span>

        {(refFormat.current && vidSrc) ? 
        
           /* onLoadedMetadata is the load signal, NOT onCanPlay. These elements are
              preload="metadata", so the browser fetches only the header and never buffers
              enough frames to satisfy canplay -- which means onCanPlay frequently never
              fires at all and the video never reports itself loaded. Page.js counts those
              reports to decide a page is done, so one video could hold a page permanently
              short of its component count. onCanPlay is kept as a second chance: onLoad is
              idempotent (bLoaded guard + 1s throttle), so whichever fires first wins. */
           (refFormat.current.autoplay ? <video data-auto="true" preload="metadata" style={vidStyle} onClick={(e) => onClickVideo(e)} ref={refVid} muted playsInline src={vidSrc} type="video/mp4" id={'video-' + refFormat.current.id} onLoadedMetadata={onLoad} onCanPlay={onLoad} onError={handleRetry}>
                <source src={vidSrc} type="video/mp4"></source>
            </video> : <video preload="metadata" style={vidStyle} id={'video-' + refFormat.current.id} onClick={(e) => onClickVideo(e)} ref={refVid} playsInline src={vidSrc} type="video/mp4" onLoadedMetadata={onLoad} onCanPlay={onLoad} onError={handleRetry}>
            <source src={vidSrc} type="video/mp4"></source>
        </video>)
        
             : <span />}

             {!canPlay && <div className={`poster-overlay`}></div>}
        </div>
        
    )

}

const VIDEO = memo( VideoComponent ,(prev,next)=>{ 
    return prev.imgSrc === next.imgSrc
})

export  {VIDEO}
